function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecord = function SvgRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.001 9c0 4.114-3.515 7.449-7.852 7.449S4.296 13.114 4.296 9s3.516-7.449 7.853-7.449S20 4.886 20 9zm1.309 0c0 4.8-4.102 8.69-9.161 8.69-5.06 0-9.161-3.89-9.161-8.69 0-4.8 4.101-8.69 9.16-8.69C17.209.31 21.31 4.2 21.31 9zm-9.161 2.897c1.686 0 3.053-1.297 3.053-2.897 0-1.6-1.367-2.897-3.053-2.897C10.462 6.103 9.095 7.4 9.095 9c0 1.6 1.367 2.897 3.054 2.897z",
    style: {
      strokeWidth: 0.849763
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "6.66667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    x: 4.621,
    y: 23.895
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.621,
    y: 23.895,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "6.66667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, "REC")));
};
export default SvgRecord;